/**
 * True while the page is being rendered by the build-time prerenderer
 * (vite.config.ts injects `__PRERENDER_INJECTED` before any app script runs).
 *
 * Ad pixels MUST gate on this: during prerender the prod bundle runs against
 * 127.0.0.1 with no internal-traffic flag, so the pixels initialized and their
 * dynamically-injected <script> tags were serialized into the shipped static
 * HTML — every real visitor then loaded a stale 127.0.0.1-configured pixel
 * before any fbq/rdt stub existed ("fbq is not defined" + "multiple pixels
 * with conflicting versions", found 2026-08-12 while Meta ads were in review).
 */
export function isPrerendering(): boolean {
  if (typeof window === 'undefined') return false;
  return Boolean((window as unknown as { __PRERENDER_INJECTED?: unknown }).__PRERENDER_INJECTED);
}
